import { gql } from "@shared/utils";
import { FunctionComponent } from "react";
import { useGqlField } from "../../../../../hooks";
import { DVInlineProps } from "../types";
import {useMutation} from '@apollo/client/react';
import { CoreInlineNumber } from "../../../../Inputs/CoreInlineNumber";

const EDIT_NUMBER = gql`
  mutation UpdateDynamicVariable($id: String!, $value: Float) {
    updateDynamicVariable(input: { id: $id, number: $value }) {
      _id
      number
    }
  }
`;

const EDIT_UNIT = gql`
  mutation UpdateDynamicVariable($id: String!, $value: String!) {
    updateDynamicVariable(input: { id: $id, unit: $value }) {
      _id
      unit
    }
  }
`;

export const DVInlineNumber: FunctionComponent<DVInlineProps> = ({
  dynamicVariable,
  textFieldProps,
}) => {
  const [updateNumber] = useMutation(EDIT_NUMBER);
  const [unit, setUnit] = useGqlField(
    dynamicVariable.unit || "",
    dynamicVariable._id,
    EDIT_UNIT
  );
  return (
    <CoreInlineNumber
      textFieldProps={textFieldProps}
      number={dynamicVariable.number}
      unit={unit}
      onNumberChange={(number) => {
        updateNumber({ variables: { id: dynamicVariable._id, value: number } });
      }}
      onUnitChange={(unit) => {
        setUnit(unit);
      }}
    />
  );
};
